<template>
  <v-navigation-drawer
    v-if="!mobile"
    v-model="slide"
    color='i-powderblue'
    app
    left
  >

    <v-container
      align="center"
      justify="center"
    >
      <router-link to="/login">
        <div class="login-item cyan lighten-5"
          align="center"
          justify="center"
        >
          <v-icon x-large>mdi-account-box</v-icon>
            
            <v-list-item-content>
              <v-list-item-title class="black--text">Login</v-list-item-title>
            </v-list-item-content>
        </div>
      </router-link>
    </v-container>

    <v-list dense>
      <v-list-item v-for="(link, sn) in navLinks" :key="sn" link :to="link.route" class="pl-10">
        <v-list-item-action>
          <v-icon>{{link.icon}}</v-icon>
        </v-list-item-action>

        <v-list-item-content>
          <h4>{{link.title}}</h4>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>

  <v-navigation-drawer
    v-else-if="mobile"
    v-model="slide"
    color='i-powderblue'
    app
    right
  >
    <v-container
      align="center"
      justify="center"
    >
      <router-link to="/login">
        <div class="login-item cyan lighten-5"
          align="center"
          justify="center"
        >
          <v-icon x-large>mdi-account-box</v-icon>
            
            <v-list-item-content>
              <v-list-item-title class="black--text">Login</v-list-item-title>
            </v-list-item-content>
        </div>
      </router-link>
    </v-container>

    <v-list dense>
      <v-list-item v-for="(link, sn) in navLinks" :key="sn" link :to="link.route" class="pl-7">
        <v-list-item-action class="mr-0">
          <v-icon>{{link.icon}}</v-icon>
        </v-list-item-action>

        <v-list-item-content align="center" class="ml-0 mr-12">
          <h4 class="i-darkblue--text">{{link.title}}</h4>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'i-navigation',

  props: {
    drawer: { type: Boolean },
  },

  data: () => ({
    slide: null,

    navLinks: [
      {sn: 1, title: 'Home', route: '/', icon: 'mdi-home'},
      {sn: 2, title: 'About', route: '/about', icon: 'mdi-book'},
      {sn: 3, title: 'Contact', route: '/contact', icon: 'mdi-contacts'},
      {sn: 4, title: 'Help', route: '/help', icon: 'mdi-help'},
      {sn: 5, title: 'Legal', route: '/legal', icon: 'mdi-information'},
      {sn: 6, title: 'Report', route: '/report', icon: 'mdi-bug'}
    ]
  }),

  computed: {
    mobile () {
      let value
      window.innerWidth <= 760
      ? value = true
      : value = false

      return value
    }
  },

  watch: {
    drawer () {
      this.slide = this.drawer
    },

    slide () {
      !this.slide
      ? this.$emit("retract")
      : this.slide = this.drawer
    }
  }
}
</script>

<style scoped>
/* MOBILE */
@media screen and (max-width: 1023px) {
  .v-navigation-drawer {
    border-radius: 0px 1.5rem 1.5rem 0px !important;
  }
}

.v-navigation-drawer {
  border-radius: 1.5rem 0px 0px 0px;
}

a.v-list-item--active {
  background: var(--blue) !important
}

a.v-list-item:hover {
  background: var(--lightblue) !important
}

a.v-list-item--active h4 {
  font-size: 1.3rem;
  color: white !important
}

a[href*="/login"] {
  color: transparent
}

.login-item {
  width: 32.5%;
  margin-left: auto;
  margin-right: auto;
  border-radius: 50%;
  box-shadow: -0.5px 0.1rem 0.5rem 0.5px rgba(0,0,0,0.25);
  transition: 0.25s;
}

.login-item:hover {
  box-shadow: -0.5px 0.15rem 0.5rem 0.5px rgba(0,0,0,0.5);
  transition: 0.5s;
}
</style>
